import React from "react";
import { tinaField } from "@/lib/utils";

import Link from "@/components/ui/link";
import { Button } from "@/components/ui/button";
import Section from "@/components/Section";
import TextTooltip from "@/components/TextTooltip";

export default function CallToAction({ callToAction }) {
  return (
    <Section
      wrapperClassName="!py-24"
      className="flex flex-col items-center text-center gap-8 lg:gap-12"
    >
      <div className="flex flex-col gap-6">
        <h2
          className="h2 max-w-3xl mx-auto"
          data-tina-field={tinaField(callToAction, "title")}
        >
          {callToAction?.title}
        </h2>
        <TextTooltip
          text={callToAction?.description}
          className="p-lg max-w-3xl mx-auto"
          data-tina-field={tinaField(callToAction, "description")}
        />
      </div>
      <Button
        href={callToAction?.button?.link}
        data-tina-field={tinaField(callToAction, "button.label")}
        size="lg"
        asChild
      >
        <Link href={callToAction?.button?.link || "/"}>
          {callToAction?.button?.label}
        </Link>
      </Button>
    </Section>
  );
}
